import React from 'react'
import {Link} from 'react-router-dom';

export default function PrimaryButton({path,slug,title,color,background}) {
    return (
        <div className="btn-primary" style={{color:{color},backgroundColor:background}}>
            <Link to={`/${path}/${slug}`}>{title}</Link>
        </div>
    )
}
